module.exports = __webpack_public_path__ + "static/logo-6b3a8fc824dda3e19a21dc27c6164b28.svg";